import { PartnerHomePage } from 'components/pages/PartnerHome'

export default PartnerHomePage
